import { jsx as _jsx } from "react/jsx-runtime";
import { ConstituentTrialActivationDialogContent } from '@modules/constituents/constituent-trial/constituent-trial-activation-dialog-content';
import { RequestingTrialLoader } from '@modules/constituents/constituent-trial/requesting-trial-loader';
import { ConstituentTrialOfflineModeDialogContent } from '@modules/constituents/constituent-trial/constituent-trial-offline-mode-dialog-content';
import { useRequestConstituentTrial } from '@modules/constituents/constituent-trial/use-request-constituent-trial';
import { useServerConfigContext } from '@common/server-config-context/server-config-context';
import { useIdeProvisionerConstituent } from '@common/queries/ide-provisioner';
export function IdepTrialContent({ onClose, changeStep, plan, ...rest }) {
    const serverConfig = useServerConfigContext();
    const offlineModeEnabled = serverConfig.isOfflineMode();
    const { mutate, isLoading: isMutating } = useRequestConstituentTrial('idep', changeStep);
    const { data } = useIdeProvisionerConstituent();
    const canSkipTrial = plan !== 'PREPAID' && (data === null || data === void 0 ? void 0 : data.status) !== 'disabled_by_license';
    if (isMutating) {
        return _jsx(RequestingTrialLoader, { ...rest });
    }
    if (offlineModeEnabled) {
        return (_jsx(ConstituentTrialOfflineModeDialogContent, { onCancel: onClose, onSkip: changeStep, ...rest }));
    }
    return (_jsx(ConstituentTrialActivationDialogContent, { product: "IDE Provisioner", onActivateTrial: mutate, onCancel: onClose, onSkip: changeStep, skipTrialButtonEnabled: canSkipTrial, ...rest }));
}
